/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {Injectable, TemplateRef} from '@angular/core';
import {Subject} from 'rxjs';
import Editor from '../../Editor';

/**
 * Menu service.
 */
@Injectable({
    providedIn: 'root'
})
export class MenuService {
    /**
     * Editor instance.
     */
    editor: Editor;

    /**
     * Custom menu reference change.
     */
    customMenuRefChange: Subject<TemplateRef<any>> = new Subject<TemplateRef<any>>();

    /**
     * Set custom menu reference.
     * 
     * @param c Template reference.
     */
    setCustomMenuRef(c: TemplateRef<any>): void {
        this.customMenuRefChange.next(c);
    }
}
